import type { Action, ActionCreatorWithoutPayload, ActionCreatorWithPayload, ThunkDispatch } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/browser';
import { AxiosError } from 'axios';
import { ErrorResponse } from '../apis/EnterpriseApiV1';
import { DEFAULT_ERROR } from '../const/messageCodes';

export const reduxErrorHandler = (
  e: any,
  dispatch: ThunkDispatch<any, undefined, Action<string>>,
  errorReceived: ActionCreatorWithPayload<any, any> | ActionCreatorWithoutPayload<any>,
  errorMessageCode: string,
  errorSubstitutions?: Record<string, string>,
) => {
  const error: AxiosError<ErrorResponse> = e;
  Sentry.captureEvent(error);
  console.error(error);
  if (!error.response) {
    return dispatch(errorReceived({ messageCode: DEFAULT_ERROR }));
  }

  const { status, data } = error.response;
  if (status === 401) {
    window.location.href = `${__SCHEDULING_HOST__}/login.php`;
    return;
  }

  dispatch(errorReceived({ message: errorMessageCode, substitutions: errorSubstitutions }));

  return Promise.reject(data.error);
};
